import * as moment from "moment"
import { ModelAssumptionsUtil } from "src/app/core/v2/state/valuation-process/core/income/model-assumptions-util"
import { CostAssessmentRecordRow, DepreciatedRecordRow } from "../../types"
import { RecordOptions } from "./calculation"
import { normalizeRecords } from "./normalize"
import { recordsHasNullDepreciatedCost, totalCostOfRecords, totalDepreciatedCostOfRecords } from "./utils"

export interface PhysicalObsolescenceOptions {
  kind: 'physical-obsolescence',
  physicalDepreciationFactor: number
}

export function physicalObsolescenceMethod(
  records: CostAssessmentRecordRow[],
  recordOptions: RecordOptions,
  physicalObsolescenceOptions: PhysicalObsolescenceOptions
) {
  const {
    physicalDepreciationFactor
  } = physicalObsolescenceOptions
  const {
    valuationDate,
    buildingConstructionDate,
    size
  } = recordOptions
  const _records = normalizeRecords(records, recordOptions)
  const _physicalDepreciationFactor = physicalDepreciationFactor / 100
  const _valuationDate = moment(valuationDate)
  const _buildingConstructionDate = moment(buildingConstructionDate)
  const yearDiff = ModelAssumptionsUtil._yearsDiff(
    _valuationDate,
    _buildingConstructionDate
  )

  const mappedRecords: DepreciatedRecordRow[] = _records.map(item => {
    const depreciatedCost = physicalObsolescence(
      item.total_cost,
      _physicalDepreciationFactor
    )
    return {
      ...item,
      depreciated_cost: depreciatedCost,
      depreciated_per_unit: size && size !== 0 ? depreciatedCost / size : 0
    }
  })

  if (recordsHasNullDepreciatedCost(mappedRecords)) return null

  const totalCost = totalCostOfRecords(mappedRecords) 
  const totalDepreciatedCost = totalDepreciatedCostOfRecords(mappedRecords)  

  return {
    records: mappedRecords,
    graphValues: [],
    totalCost,
    totalDepreciatedCost,
    yearDiff
  }
}

export function physicalObsolescence(
  totalCost: number,
  physicalDepreciationFactor: number
) {
  return totalCost * (1 - physicalDepreciationFactor)
}